import {
  SET_AGENT_DETAILS,
  AGENT_DETAILS_ERROR,
  SET_AGENCY_DETAILS
} from '../actions/quote'

const initialState = {
  agent: null,
  agency: null,
  isLoading: false,
  hasErrors: false
}

const agencyDetails = (state = initialState, action) => {
  switch (action.type) {
    case SET_AGENT_DETAILS:
      return Object.assign({}, state, {
        agent: action.payload,
        isLoading: false,
        hasErrors: false
      })
    case AGENT_DETAILS_ERROR:
      return Object.assign({}, state, {
        hasErrors: true
      })
    case SET_AGENCY_DETAILS:
      return Object.assign({}, state, {
        agency: action.payload
      })
    default:
      return state
  }
}

export default agencyDetails
